import React from "react";

import type { FileModel } from "@admin/domain/files/model/FileModel";
import type { Language } from "@admin/domain/languages/helpers";
import type { Banner } from "./index";
import Input from "@admin/components/Input";
import MultiLanguages from "@admin/components/MultiLanguage";
import ImageInput from "@admin/components/ImageInput";
import JoditEditor from "@admin/components/JoditEditor";

type Props = {
    setBanner: React.Dispatch<React.SetStateAction<Banner>>;
    banner: Banner;
};

export default function Fields({ setBanner, banner }: Props) {
    return (
        <>
            <div className="d-flex align-items-center justify-content-center">
                <ImageInput
                    label="Изображение"
                    name=""
                    onChange={(file: FileModel | null): void => setBanner({ ...banner, file })}
                    defaultValue={banner.file}
                />
            </div>

            <MultiLanguages
                languageElement={(language: Language) => (
                    <>
                        <Input
                            label="Заголовок"
                            onChange={(event) =>
                                setBanner((prev) => {
                                    const { title } = prev;
                                    title[language] = event.target.value;
                                    return { ...prev, title };
                                })
                            }
                            value={banner.title[language]}
                        />

                        <JoditEditor
                            label="Текст под заголовком"
                            name={`[${banner.id}][description][${language}]`}
                            initHtml={banner.description[language] || ``}
                            onBlur={(value) =>
                                setBanner((prev) => {
                                    const { description } = prev;
                                    description[language] = value;
                                    return { ...prev, description };
                                })
                            }
                        />

                        <Input
                            label="Текст кнопки"
                            onChange={(event) =>
                                setBanner((prev) => {
                                    const { button_text } = prev;
                                    button_text[language] = event.target.value;
                                    return { ...prev, button_text };
                                })
                            }
                            value={banner.button_text[language]}
                        />

                        <Input
                            label="Тег"
                            onChange={(event) =>
                                setBanner((prev) => {
                                    const tag = prev.tag;
                                    tag[language] = event.target.value;
                                    return { ...prev, tag };
                                })
                            }
                            value={banner.tag[language]}
                        />
                    </>
                )}
            />

            <Input
                label="Ссылка"
                onChange={(event) => setBanner((prev) => ({ ...prev, url: event.target.value }))}
                value={banner.url}
            />
        </>
    );
}
